import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 30.7.",
  "description": "",
  "published": "2011-07-30T00:00:00.000Z",
  "redirect_from": ["/blog/2037/swizec/2037"],
  "categories": "Engineering and Technology, History, Learning, Personal, Semaphore line, Telegraphy, Text messaging",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/07/300px-Chappe_telegraf1.jpg",
        "alt": "Chappe telegraf at Louvre, Paris",
        "title": "Chappe telegraf at Louvre, Paris"
      }}></img></p>
    <p>{`Today I came upon an interesting article on hackernews about the first ever text message from some time in the 19th century. It was referring to the telegraph. -> `}<a parentName="p" {...{
        "href": "http://sundaymagazine.org/2010/08/from-1890-the-first-text-messages/"
      }}>{`From 1890: The First Text Messages`}</a>{`.`}</p>
    <p>{`Actually both of the things I learned stem from that article.`}</p>
    <p>{`The first that I learned is that such a thing as `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Semaphore_line"
      }}>{`optical telegraphs`}</a>{` actually existed at one time. I had thought this was something Terry Pratchet invented out of thin air, but apparently in the late 18th and early 19th century they actually existed. Even though they were hypothesised about in the late 17th century, the first practical implementation was by `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Claude_Chappe",
        "title": "Claude Chappe"
      }}>{`Chappe`}</a>{` in France.`}</p>
    <p>{`It's really quite fascinating, people `}<em parentName="p">{`actually`}</em>{` communicated by turning rods into shapes up on high towers. The mechanical complexity is just mindboggling.`}</p>
    <p>{`Another thing that I learned is that telegraph operators back in the day had wars. Apparently sometimes two of them wanted to relay a message and instead of using some sort of protocol to arrange who would go first ... they'd just both go at the same time until one of them finally gave up control. Seems rather inefficient, especially as neither of them could really tell what the other was saying.`}</p>
    <p>{`Fascinating stuff that.`}</p>
    <p>{`Luckily internet doesn't work that way ...`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/i-learned-two-things-today-29-7/swizec/2022"
        }}>{`I learned two things today 29.7.`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://sundaymagazine.org/2010/08/from-1890-the-first-text-messages/"
        }}>{`From 1890: The First Text Messages`}</a>{` (sundaymagazine.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://ruralcommunication.wordpress.com/2011/07/30/wtf-and-other-rural-text-messages/"
        }}>{`WTF and other rural text messages`}</a>{` (ruralcommunication.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.textually.org/textually/archives/2011/07/029102.htm"
        }}>{`Short text messages show surprising storytelling power in Norway tragedy`}</a>{` (textually.org)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=9ae04d84-203e-48aa-8660-8ee9d01934b6",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      